module.exports = __webpack_public_path__ + "static/website-1116bb44c4184c7f0b0c91bc4179bf62.jpg";